import script from "./Areas.vue?vue&type=script&setup=true&lang=js"
export * from "./Areas.vue?vue&type=script&setup=true&lang=js"

import "./Areas.vue?vue&type=style&index=0&id=43697822&lang=css"
import "./Areas.vue?vue&type=style&index=1&id=43697822&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43697822"]])

export default __exports__